<div class="modal-header">
  <h4 class="modal-title synchpc-primary flex-grow-1" id="modal-title">Send Broadcast Message</h4>
  <button class="default-btn"
          (click)="changeFormToUpdateServiceBroadcast()"
          title="Update active service broadcast messages."
          style="font-size:inherit; margin-right:2px">
    <span class="bi bi-pencil-square"></span>
    Edit
  </button>
  <i class="bi bi-x-lg text-danger" style="font-size:larger" (click)="onClose()"></i>
</div>

<div class="modal-body text-grey">
  <form spellcheck="false" autocomplete="off" [formGroup]="serviceBroadcastForm" (ngSubmit)="addServiceBroadcast(serviceBroadcastForm)">

    

    <!-- <mat-form-field *ngIf="updateServiceBroadcast == true" style="width: 100%; margin-top: 1%"
                    appearance="fill"
                    matTooltip="Select date and time till notification should display">
      <input [min]="minDate"
             [max]="maxDate"
             matInput
            [owlDateTimeTrigger]="dt1"
             placeholder="Expiration Time. Default is one day. (Optional)"
             formControlName="expirationTime" />
      <mat-datepicker-toggle (click)="valueChanged()" matSuffix [for]="picker1"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker #picker1></ngx-mat-datetime-picker>
    </mat-form-field> -->
    @if(updateServiceBroadcast == true){
      <mat-form-field appearance="fill" style="width: 100%;" matTooltip="Select Title" matTooltipPosition="above">
        <mat-label>Select Title</mat-label>
        <mat-select formControlName="id" (selectionChange)="optionClicked($event.value)">
          <mat-option *ngFor="let broad of allActiveServiceBroadcastList" [value]="broad.id">
            {{ broad.title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-form-field style="width: 100%; margin-top:1%">
        <mat-label>Title</mat-label>
        <input formControlName="title" matInput />
        <mat-error *ngIf="
              serviceBroadcastForm.get('title').errors?.required
            ">
          Enter Title. *required
        </mat-error>
      </mat-form-field>
  
      <mat-form-field style="width: 100%; margin-top: 1%">
        <mat-label>Message</mat-label>
        <textarea formControlName="message" matInput></textarea>
        <mat-error *ngIf="
              serviceBroadcastForm.get('message').errors?.required
            ">
          Enter Message. *required
        </mat-error>
      </mat-form-field>
  
      <mat-form-field style="width: 100%; margin-top: 1%">
        <mat-label>Deployment Users To Show</mat-label>
        <mat-select formControlName="deploymentUsersToShow" multiple>
          <mat-option [disabled]="depSelectionChange(dep)" *ngFor="let dep of depName" value="{{ dep }}">
            {{
              dep
            }}
          </mat-option>
          <mat-error *ngIf="
              serviceBroadcastForm.get('deploymentUsersToShow').errors?.required
            ">
            Select deployment. *required
          </mat-error>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-100" style="margin-top: 1%" appearance="fill" matTooltip="Select date and time till notification should display">
        <mat-label>Select date and time till notification should display</mat-label>
        <input matInput
               [min]="minDate"
               [max]="maxDate"
               [owlDateTimeTrigger]="dt8"
               [owlDateTime]="dt8"
               placeholder="Expiration Time. Default is one day. (Optional)"
               formControlName="expirationTime">
        <owl-date-time #dt8></owl-date-time>
      </mat-form-field>

      <mat-form-field *ngIf="updateServiceBroadcast == true" style="width: 100%; margin-top:1%">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option value="active">Active</mat-option>
          <mat-option value="deactivate">Deactivate</mat-option>
        </mat-select>
      </mat-form-field>
    } @else {
      <mat-form-field style="width: 100%; margin-top:1%">
        <mat-label>Title</mat-label>
        <input formControlName="title" matInput />
        <mat-error *ngIf="
              serviceBroadcastForm.get('title').errors?.required
            ">
          Enter Title. *required
        </mat-error>
      </mat-form-field>
  
      <mat-form-field style="width: 100%; margin-top: 1%">
        <mat-label>Message</mat-label>
        <textarea formControlName="message" matInput></textarea>
        <mat-error *ngIf="
              serviceBroadcastForm.get('message').errors?.required
            ">
          Enter Message. *required
        </mat-error>
      </mat-form-field>
  
      <mat-form-field style="width: 100%; margin-top: 1%">
        <mat-label>Deployment Users To Show</mat-label>
        <mat-select formControlName="deploymentUsersToShow" multiple>
          <mat-option [disabled]="depSelectionChange(dep)" *ngFor="let dep of depName" value="{{ dep }}">
            {{
              dep
            }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="
              serviceBroadcastForm.get('deploymentUsersToShow').errors?.required
            ">
          Select deployment. *required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" style="margin-top: 1%" appearance="fill" matTooltip="Select date and time till notification should display">
        <mat-label>Select date and time till notification should display</mat-label>
        <input matInput
               [min]="minDate"
               [max]="maxDate"
               [owlDateTimeTrigger]="dt8"
               [owlDateTime]="dt8"
               placeholder="Expiration Time. Default is one day. (Optional)"
               formControlName="expirationTime">
        <owl-date-time #dt8></owl-date-time>
      </mat-form-field>
<!--   
      <mat-form-field style="width: 100%; margin-top: 1%"
                      appearance="fill"
                      matTooltip="Select date and time till notification should display">
        <input [min]="minDate"
               [max]="maxDate"
               matInput
              [owlDateTimeTrigger]="dt1"
               placeholder="Expiration Time. Default is one day. (Optional)"
               formControlName="expirationTime" />
        <mat-datepicker-toggle (click)="valueChanged()" matSuffix [for]="picker1"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #picker1></ngx-mat-datetime-picker>
      </mat-form-field> -->
    }
  </form>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary" *ngIf="updateServiceBroadcast == false"
            (click)="addServiceBroadcast(serviceBroadcastForm)">
      Submit
    </button>
    <button type="button" class="btn btn-primary" *ngIf="updateServiceBroadcast == true"
            (click)="updateActiveServiceBroadcasts(serviceBroadcastForm)">
      Submit
    </button>
  </div>
</div>
